import { field, date, relation,text } from '@nozbe/watermelondb/decorators';
import { Model } from '@nozbe/watermelondb';
import { ORDERS_SCHEMA } from '../schema';

export default class Orders extends Model {
    static table = ORDERS_SCHEMA;

    static associations = {
        business: { type: 'belongs_to', key: 'business_id' },
        invoice: { type: 'belongs_to', key: 'invoice_id' },
        payment: { type: 'belongs_to', key: 'payment_id' },
        stock: { type: 'belongs_to', key: 'stock_id' },
        txns: { type: 'belongs_to', key: 'txns_id' },
    }

    @field('is_secondary_unit') is_secondary_unit;
    @field('unit_conversion') unit_conversion;
    @text('discount_method') discount_method;
    @text('secondary_unit') secondary_unit;
    @field('selling_price') selling_price;
    @field('is_open_item') is_open_item;
    @field('cost_price') cost_price;
    @field('inclusive') inclusive;
    @text('tran_type') tran_type;
    @field('quantity') quantity;
    @field('discount') discount;
    @text('name') name;
    @text('type') type;
    @text('unit') unit;
    @field('tax') tax;

    @date('transacted_at') transacted_at;

    @relation('business', 'business_id') business;
    @relation('invoice', 'invoice_id') invoice;
    @relation('payment', 'payment_id') payment;
    @relation('stock', 'stock_id') stock;
    @relation('txns', 'txns_id') txns;
}
